import React from 'react';
import './MobileAppPopup.scss';
import Icon from '../Common/Icon';
import Button from '../Common/Button';
import {isMobile, isAndroid, isIOS} from 'react-device-detect';
import URLSearchParams from '@ungap/url-search-params'; // URLSearchParams polyfill for IE11

export default class MobileAppPopup extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            showModal: false,
        }
    }

    componentDidMount = () => {
        // eslint-disable-next-line no-undef
        const mobileAppExists = __MOBILE_APP_EXISTS__;
        const userElection = sessionStorage.getItem('userElection');

        if (isMobile && mobileAppExists && userElection !== 'no') {
            let isRedirect = this.tryRedirectToMobileApp();

            if(isRedirect){
                this.setState({ showModal: true });
            }
        }
    }

    tryRedirectToMobileApp = () => {
        //if mobile app installed, open it up and pass params with it

        const searchParams = new URLSearchParams(location.search);
        const currentPath = location.pathname;

        if(currentPath === "/tasks"){
            window.location.replace(`myrollout://tasks?${searchParams.toString()}`);
            return true;
        } else if (currentPath === "/reset-password"){
            return false;
        } else {
            window.location.replace(`myrollout://`);
            return true;
        }
    }

    onRedirect = () => {
        //TODO: replace these store links to go directly to the 4myrollout download page
        if (isAndroid) {
            window.location.replace('https://play.google.com/store/apps')
        }

        if (isIOS) {
            window.location.replace('https://www.apple.com/app-store/')
        }
    }

    onCancel = () => {
        this.setState({ showModal: false });
        sessionStorage.setItem('userElection', 'no');
    }

    render() {
        if (this.state.showModal) {
            return (
                <div className='popup-container shadow-lg'>
                    <div className="container">
                        <div className="row m-3">
                            <div className="col-2 text-center" style={{ fontSize: 26 }}>
                                <Icon name="mobile-alt"  />
                            </div>
                            <div className="col-10">
                                The Pacer mobile app can be found on the app store!
                            </div>
                        </div>
                        <div className="row m-2 flex-column">
                            <div className="row pb-1">
                                <div className="col">
                                    <Button type="submit" bootstrapClass="primary" text="Continue" onClick={this.onRedirect} />
                                </div>
                                
                            </div>
                            <div className="row" style={{ fontSize: 14 }}>
                                <Button type="submit" bootstrapClass="link" text="Continue with mobile web" onClick={this.onCancel} />
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        else return null;
    }
}